// @flow

import ElementPortal from 'react-element-portal';
import React from 'react';
import type { Node } from 'react';

import { Price } from '@zapier/currency';
import { OfferModal } from '@zapier/promotions';

import TeamsPricing from 'app/team/components/TeamsPricing';

type Props = {
  children?: Node,
};

const LandingPage = ({ children }: Props) => (
  <div>
    {children}
    <ElementPortal id="teams-pricing-amount">
      <TeamsPricing>
        {({ currency, price, isAnnual }) => (
          <span>
            Starting at <Price currency={currency}>{price}</Price>
            /mo {isAnnual && '(paid annually)'}
          </span>
        )}
      </TeamsPricing>
    </ElementPortal>
    <ElementPortal id="teams-pricing-amount-link">
      <TeamsPricing>
        {({ currency, price, isAnnual }) => (
          <span>
            Or{' '}
            <a href="/app/billing/plans/upgrade-to-team">
              buy for <Price currency={currency}>{price}</Price>
              /mo
            </a>{' '}
            {isAnnual && '(paid annually)'}
          </span>
        )}
      </TeamsPricing>
    </ElementPortal>

    <OfferModal />
  </div>
);

export default LandingPage;
